mutation DeleteComment(
    $id: ID!
) {
    deleteComment(
        id: $id
    ) {
        status
        message
    }
}
